import {ReactNode} from 'react';
import {Navigate} from 'react-router';
import {useParams} from 'react-router-dom';
import {ROUTE_PATHS} from '@di-shared/routes';

export interface ReservationNumberGuardProps {
  children(reservationNumber: string): ReactNode;
}

function ReservationNumberGuard({children}: ReservationNumberGuardProps): JSX.Element {
  const params = useParams();

  if (!params.reservationNumber) {
    return (
      <Navigate
        to={ROUTE_PATHS.ERROR.getFullPath()}
        replace
      />
    );
  }

  return <>{children(params.reservationNumber)}</>;
}

export default ReservationNumberGuard;
